// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zd5S","colMin":"styles_colMin__1oxgX"};